




































































































































import { defineComponent, ref, watch, computed, PropType } from '@vue/composition-api';
import { AccessLevel, AccessLevelsOptions } from '@/modules/access-policy/constants/access-levels.constants';
import { DatabaseIcon } from '@vue-hero-icons/solid';

import { DescriptionListCard, DescriptionListItem } from '@/app/components';
import { Asset } from '../types';
import { useAxios } from '@/app/composable';
import { AssetsAPI } from '../api';
import store from '@/app/store';

export default defineComponent({
    name: 'SharingDetailsTab',
    props: {
        asset: {
            type: Object as PropType<Asset>,
            required: true,
        },
    },
    components: {
        DescriptionListCard,
        DescriptionListItem,
        DatabaseIcon,
    },
    setup(props) {
        const metadata = { general: true, distribution: true, extent: true, licensing: true };
        const inputAssets = ref<any>([]);
        const rejectedItems = ref<number>(0);

        const { exec } = useAxios();

        const user = computed(() => store.state.auth.user);
        const isDataOwner = computed(() => user.value.id === props.asset.createdBy.id);

        watch(
            () => props.asset,
            async (newAsset) => {
                exec(AssetsAPI.getInputAssets(newAsset.id)).then((res: any) => {
                    inputAssets.value = res.data?.inputAssets;
                    rejectedItems.value = res.data?.accessControl?.rejectedItems || 0;
                });
            },
            { immediate: true },
        );

        return {
            metadata,
            AccessLevel,
            AccessLevelsOptions,
            inputAssets,
            rejectedItems,
            isDataOwner,
        };
    },
});
